/** @type {import('next').NextConfig} */
const nextConfig = {
  productionBrowserSourceMaps: true,
  output: 'export',
  trailingSlash: true,
  images: {
    unoptimized: true
  },

  basePath: '/oferta',

  sassOptions: {
    additionalData: `
    @import "src/styles/mixins";
    @import "src/styles/tokens";
    @import "src/styles/fgt-animate";
    `
  },

  webpack(config) {
    return config
  }
}

module.exports = nextConfig
